// Default search values for the search form
export const searchValues = {
  title: "",
  toDate: "",
  fromDate: "",
  messageType: "",
  messageStatus: "",
};

// Mapping of Excel header names to their corresponding data keys
export const excelHeaderCellsName = {
  "رقم المعرف": "id",
  "تاريخ الجدولة": "scheduledDateTime",
  "محتوى الرسالة": "messageContent",
  الفئة: "category",
  "حالة الرسالة": "messageStatus",
};

export const MessageStatusOptions = [
  {
    value: "1",
    english: "New",
    name: "جديد",
  },
  {
    value: "2",
    english: "InProgress",
    name: "قيد التنفيذ",
  },
  {
    value: "3",
    english: "Disabled",
    name: "معلق",
  },
  {
    value: "4",
    english: "NotSent",
    name: "لم يتم الإرسال",
  },
  {
    value: "5",
    english: "Sent",
    name: "تم الإرسال",
  },
];

export const messagesTypesOptions = [
  { value: "FailedRecurring", name: "استقطاعات فاشلة" },
  { value: "FailedDonation", name: "عمليات تبرع فاشلة" },
  { value: "CompletedProject", name: "مشاريع مكتملة" },
  { value: "SuccessDonations", name: "تبرعات ناجحة" },
];

export const clientTypeOptions = [
  { value: 0, name: "عميل جديد" },
  { value: 1, name: "عميل سايق" },
];

export const frequencyOptions = [
  { value: 0, name: "يومي" },
  { value: 1, name: "أسبوعي" },
  { value: 2, name: "شهري" },
  { value: 3, name: "سنوي" },
];

export const clientJoiningPeriodOptions = [
  { value: 0, name: "اسبوع" },
  { value: 1, name: "شهر" },
  { value: 3, name: "3 شهور" },
  { value: 4, name: "6 شهور" },
  { value: 5, name: "سنة" },
];
